import script from "./upTime.vue?vue&type=script&setup=true&lang=js"
export * from "./upTime.vue?vue&type=script&setup=true&lang=js"

import "./upTime.vue?vue&type=style&index=0&id=55a9d9b8&lang=scss&scoped=true"
import "./upTime.vue?vue&type=style&index=1&id=55a9d9b8&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a9d9b8"]])

export default __exports__